import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GavelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gavel"}/>
}
